import React, { CSSProperties } from 'react'
import { ColorFormat, Color as ColorType } from '../../../../../../types'
import styled, { css } from 'styled-components'
import ColorBackground from '@sketch/icons/color-background.svg'
import { truncateStyles } from '@sketch/components'

export interface ColorProps extends ColorType {
  style?: CSSProperties
  format?: ColorFormat
  className?: string
  $iconSize?: number
  dropFormat?: boolean
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 236px;
  font-size: 0.8125rem;
`

export const Text = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
  height: 18px;
  ${truncateStyles};
`

const ColorIconUnstyled = ({
  red,
  green,
  blue,
  alpha,
  ...props
}: ColorProps) => (
  <div
    role="img"
    aria-label={`rgba(${red}, ${green}, ${blue}, ${alpha})`}
    {...props}
  ></div>
)

export const ColorIcon = styled(ColorIconUnstyled)<ColorProps & {}>(
  ({ theme, $iconSize, red, green, blue, alpha, dropFormat }) => css`
    display: inline-block;
    position: relative;
    margin-right: 8px;
    height: ${$iconSize ?? 16}px;
    width: ${$iconSize ?? 16}px;
    flex: none;
    /* the drop format is misaligned by 1px with the other items */
    margin-left: ${dropFormat ? '1px' : undefined};

    &::before,
    &::after {
      content: '';
      border-radius: ${dropFormat
        ? '2px 8px 8px 8px; /* stylelint-disable-line scales/space */'
        : '50%'};
      position: absolute;
      inset: 0;
    }

    &::before {
      content: '';
      background-image: url(${ColorBackground});
      background-position: center center;
      background-size: cover;
    }

    &::after {
      border: 1px solid ${theme.colors.border.A};
      background: rgba(${red}, ${green}, ${blue}, ${alpha});
    }

    margin-top: 2px; /* stylelint-disable-line scales/space */
  `
)

export const textOverflowFadeEffect = css`
  text-overflow: clip;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  /* ^ needed to ensure proper positioning of the :after section below */

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 108px,
      rgba(255, 255, 255, 1) 100%
    );
    /* ^ creates a text-overflow fade effect */
    width: 100%;
    height: 100%;
  }
`
